<template>
  <v-slide-x-reverse-transition>
    <v-card
      class="elevation-5 action-details vop-bg-whisper"
      v-show="isVisible"
    >
      <div>
        <!-- Header title -->
        <v-toolbar flat color="vop-bg-whisper">
          <v-toolbar-title class="subheading ttu font-weight-medium">
            <span v-if="isEditMode">{{ messages.label.EDIT_ACTION }}</span>
            <span v-else>{{ messages.label.ADD_ACTION }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="hide()">
            <v-icon medium>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex>
              <v-form>
                <!-- Action Type -->
                <v-flex xs8>
                  <v-select
                    :disabled="isEditMode"
                    v-model="action.actionType"
                    label="Action Type"
                    v-validate="'required'"
                    :error-messages="errors.collect('actionType')"
                    data-vv-name="actionType"
                    :items="actionTypes"
                    item-text="title"
                    item-value="value"
                    required
                    :change="handleActionTypeChange(action.actionType)"
                  >
                  </v-select>
                </v-flex>
                <!-- Title -->
                <v-flex xs8>
                  <v-text-field
                    v-model="action.title"
                    v-validate="{
                      required: true,
                      max: 200,
                      regex: REGEX_TITLE
                    }"
                    :error-messages="errors.collect('title')"
                    data-vv-name="title"
                    data-vv-delay="500"
                    :counter="100"
                    label="Title"
                    required
                  >
                  </v-text-field>
                </v-flex>
                <!-- Field -->
                <v-flex
                  xs8
                  v-if="
                    !(
                      action.actionType === 'insertAppData' ||
                      action.actionType === 'runXslt'
                    )
                  "
                >
                  <v-autocomplete
                    v-model="action.field"
                    label="Field"
                    v-validate="'required'"
                    :error-messages="errors.collect('actionField')"
                    data-vv-name="actionField"
                    :items="xpathMappingsList"
                    item-text="title"
                    item-value="xpathLocation"
                    :loading="xpathMappingsListLoading"
                    required
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex>
                  <!-- Insert Attriubte -->
                  <template v-if="action.actionType === 'insertAttribute'">
                    <v-layout class="indigo lighten-5" column>
                      <v-layout row class="pt-2">
                        <v-flex xs6 offset-xs1>
                          <v-text-field
                            v-model="action.attributeName"
                            v-validate="'required|max:200|alpha_dash'"
                            :error-messages="errors.collect('attributeName')"
                            data-vv-name="attributeName"
                            label="Attribute Name"
                            required
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs6 offset-xs1>
                          <v-text-field
                            v-model="action.attributeValue"
                            v-validate="{
                              required: true,
                              max: 200,
                              regex: REGEX_ISO8859_1
                            }"
                            :error-messages="errors.collect('attributeValue')"
                            data-vv-name="attributeValue"
                            label="Attribute Value"
                            required
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </template>
                  <!-- Delete Attribute -->
                  <template v-if="action.actionType === 'deleteAttribute'">
                    <v-layout class="indigo lighten-5" row wrap>
                      <v-flex xs6 offset-xs1>
                        <v-text-field
                          v-model="action.attributeName"
                          v-validate="'required|max:200|alpha_dash'"
                          :error-messages="errors.collect('attributeName')"
                          data-vv-name="attributeName"
                          label="Attribute Name"
                          required
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </template>
                  <!-- Insert Element -->
                  <template v-if="action.actionType === 'insertElement'">
                    <v-layout class="indigo lighten-5" row wrap>
                      <v-flex xs6 offset-xs1>
                        <v-text-field
                          v-model="action.elementName"
                          v-validate="'required|max:200|alpha_dash'"
                          :error-messages="errors.collect('elementName')"
                          data-vv-name="elementName"
                          label="Element Name"
                          required
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </template>
                  <!-- Updte Element -->
                  <template v-if="action.actionType === 'updateElement'">
                    <v-layout class="indigo lighten-5" row wrap>
                      <v-flex xs6 offset-xs1>
                        <v-text-field
                          v-model="action.elementName"
                          v-validate="'required|max:200|alpha_dash'"
                          :error-messages="errors.collect('elementName')"
                          data-vv-name="elementName"
                          label="Updated with Name"
                          required
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </template>
                  <!-- Delete Element -->
                  <template v-if="action.actionType === 'deleteElement'">
                    <!-- Nothing -->
                  </template>
                  <!-- Insert App Data -->
                  <template v-if="action.actionType === 'insertAppData'">
                    <v-layout class="indigo lighten-5" column>
                      <v-layout row class="pt-2">
                        <v-flex xs6 offset-xs1>
                          <v-select
                            v-model="action.assetClass"
                            label="Asset Class"
                            v-validate="'required'"
                            :error-messages="errors.collect('assetClass')"
                            data-vv-name="assetClass"
                            :items="assetClassList"
                            item-text="title"
                            item-value="value"
                            required
                          >
                          </v-select>
                        </v-flex>
                      </v-layout>
                      <v-layout row class="pt-2">
                        <v-flex xs6 offset-xs1>
                          <v-text-field
                            v-model="action.appDataName"
                            v-validate="'required|max:200|alpha_dash'"
                            :error-messages="errors.collect('appDataName')"
                            data-vv-name="appDataName"
                            label="Name"
                            required
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs6 offset-xs1>
                          <v-text-field
                            v-model="action.appDataValue"
                            v-validate="{
                              required: true,
                              max: 200,
                              regex: REGEX_ISO8859_1
                            }"
                            :error-messages="errors.collect('appDataValue')"
                            data-vv-name="appDataValue"
                            label="Value"
                            required
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </template>
                  <!-- Run XSLT -->
                  <template v-if="action.actionType === 'runXslt'">
                    <v-layout class="indigo lighten-5 pt-2" row>
                      <v-flex xs10 offset-xs1>
                        <XSLTEditor v-model="xsltValue" />
                        <label
                          v-if="xsltValidationMessage"
                          class="pl-0 body-1 red--text"
                          >{{ xsltValidationMessage }}</label
                        >
                      </v-flex>
                    </v-layout>
                  </template>
                </v-flex>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
      </div>
      <v-card-actions class="px-3">
        <v-spacer />
        <!-- Delete Action -->
        <v-dialog v-model="deleteDialog" width="500" v-if="isEditMode">
          <v-btn color="error" slot="activator">
            {{ messages.label.REMOVE }}
          </v-btn>
          <v-card>
            <v-card-title class="subheading ttu">
              {{ messages.label.DELETE_ACTION }}
            </v-card-title>
            <v-card-text>
              <p>
                {{ messages.info.DELETE_ACTION_MSG }}
                <b>{{ action.title }}</b> ?
              </p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey lighten-1 white--text"
                @click="deleteDialog = false"
              >
                {{ messages.label.CANCEL }}
              </v-btn>
              <v-btn color="error" @click="deleteAction">
                {{ messages.label.DELETE }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn
          color="primary"
          class="ml-2"
          :disabled="updatingAction"
          :loading="updatingAction"
          v-if="isEditMode"
          @click="updateAction"
        >
          {{ messages.label.DONE }}
        </v-btn>
        <v-btn
          color="primary"
          class="ml-2"
          :disabled="addingAction"
          :loading="addingAction"
          @click="addAction"
          v-else
        >
          {{ messages.label.ADD }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-slide-x-reverse-transition>
</template>

<script>
import uniqid from "uniqid";
import "brace/mode/json";
import "brace/theme/eclipse";
import "brace/ext/searchbox";
import { mapState, mapActions } from "vuex";
import * as xvatRulesDataService from "@/XVAT/XVATDataService";
import messages from "@/XVAT/messages.json";
import XVATRulesService from "@/XVAT/XVATRulesService";
import { GET_XPATH_MAPPINGS_LIST } from "@/store/constants/action-types";
import * as utils from "@/Shared/utils";
import { REGEX_TITLE, REGEX_ISO8859_1 } from "@/Shared/constants";
import XSLTEditor from "./XSLTEditor.vue";

export default {
  name: "ActionDetails",
  $_veeValidate: {
    validator: "new"
  },
  components: {
    XSLTEditor
  },
  data() {
    return {
      xsltValue: "",
      xsltValidationMessage: "",
      action: {
        id: "",
        title: "",
        actionType: "",
        field: "",
        elementName: "",
        attributeName: "",
        attributeValue: "",
        assetClass: "",
        appDataName: "",
        appDataValue: "",
        xslt: ""
      },
      loadingXpathMappings: false,
      actionTypes: this.retrieveActionTypes(),
      assetClassList: this.retrieveAssetClassList(),
      isEditMode: false,
      isVisible: false,
      valid: false,
      deleteDialog: false,
      dictionary: this.getValidationDictionary(),
      addingAction: false,
      updatingAction: false,
      REGEX_TITLE: REGEX_TITLE,
      REGEX_ISO8859_1: REGEX_ISO8859_1
    };
  },
  computed: {
    ...mapState("xvat", ["xpathMappingsList", "xpathMappingsListLoading"])
  },
  watch: {
    action: {
      handler(newValue, oldValue) {
        // Populate data when the action selection changes
        if (newValue.id !== oldValue.id && !this.$lodash.isEmpty(newValue.id)) {
          this.populateActionData(newValue);
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("xvat", [GET_XPATH_MAPPINGS_LIST]),

    /**
     * hide - Hide side sheet view
     */
    hide() {
      this.isVisible = false;
      this.resetActionDetails();
      XVATRulesService.$emit("event:hideActionDetailsSheet");
    },

    /**
     * show - Show side sheet view
     */
    show(action) {
      this.resetActionData();
      // Wait before updating form
      this.$nextTick(() => {
        this.isVisible = true;
        this.$validator.reset();
        if (
          !this.$lodash.isUndefined(action) &&
          !this.$lodash.isEmpty(action)
        ) {
          this.isEditMode = true;
          this.action = this.$lodash.cloneDeep(action);
          if (this.action.actionType === "insertAppData") {
            this.action.appDataValue = utils.unEscapeXMLString(
              this.action.appDataValue
            );
          }
        } else {
          this.isEditMode = false;
        }
      });
    },

    /**
     * reseActionData - re initializes data for this view
     */
    resetActionData() {
      this.action = {
        id: "",
        title: "",
        actionType: "",
        field: "",
        elementName: "",
        attributeName: "",
        attributeValue: "",
        assetClass: "",
        appDataName: "",
        appDataValue: "",
        xslt: ""
      };
      this.xsltValue = "";
    },

    /**
     * retrieveActionTypes - List of action types supported
     * @returns {array}
     */
    retrieveActionTypes() {
      let actionTypes = [
        {
          id: 1,
          title: "Insert Attribute",
          value: "insertAttribute"
        },
        {
          id: 2,
          title: "Delete Attribute",
          value: "deleteAttribute"
        },
        {
          id: 3,
          title: "Insert Element",
          value: "insertElement"
        },
        {
          id: 4,
          title: "Update Element",
          value: "updateElement"
        },
        {
          id: 5,
          title: "Delete Element",
          value: "deleteElement"
        },
        {
          id: 6,
          title: "Insert App Data",
          value: "insertAppData"
        },
        {
          id: 7,
          title: "Run XSLT",
          value: "runXslt"
        }
      ];

      return actionTypes;
    },

    /**
     * retrieveActionTypes - List of action types supported
     * @returns {array}
     */
    retrieveAssetClassList() {
      let assetClass = [
        {
          id: 1,
          title: "Package",
          value: "package"
        },
        {
          id: 2,
          title: "Movie",
          value: "movie"
        },
        {
          id: 3,
          title: "Title",
          value: "title"
        },
        {
          id: 4,
          title: "Preview",
          value: "preview"
        },
        {
          id: 5,
          title: "Closed Caption",
          value: "closed caption"
        },
        {
          id: 6,
          title: "Poster",
          value: "poster"
        },
        {
          id: 7,
          title: "Box Cover",
          value: "box cover"
        },
        {
          id: 7,
          title: "HighRes Art",
          value: "HighRes Art"
        },
        {
          id: 7,
          title: "Trailer",
          value: "trailer"
        }
      ];

      return assetClass;
    },

    /**
     * getValidationDictionary - Validation messages for vee-validate
     * @returns {object}
     */
    getValidationDictionary() {
      return {
        custom: {
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 200 characters",
            regex: "Please use valid characters: A-Z a-z 0-9 / _ - and space"
          },
          actionField: {
            required: () => "Field can't be empty"
          },
          actionType: {
            required: () => "Action Type can't be empty"
          },
          elementName: {
            required: () => "Element Name can't be empty",
            max: "Element Name may not be greater than 200 characters",
            alpha_dash: () => "Please use valid characters: A-Z a-z 0-9 _ -"
          },
          attributeName: {
            required: () => "Attribute Name can't be empty",
            max: "Attribute Name may not be greater than 200 characters",
            alpha_dash: () => "Please use valid characters: A-Z a-z 0-9 _ -"
          },
          attributeValue: {
            required: () => "Attribute Value Type can't be empty",
            regex:
              "Contains invalid characters. Please only use ISO-8859-1 characters, excluding double quotes."
          },
          appDataName: {
            required: () => "AppData Name can't be empty",
            max: "AppData Name may not be greater than 200 characters",
            alpha_dash: () => "Please use valid characters: A-Z a-z 0-9 _ -"
          },
          appDataValue: {
            required: () => "AppData Value Type can't be empty",
            regex:
              "Contains invalid characters. Please only use ISO-8859-1 characters, excluding double quotes."
          }
        }
      };
    },

    /**
     * addAction - Add new action
     */
    addAction() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.action.actionType === "runXslt") {
            // Validation for XSLT
            this.validateXSLT(this.xsltValue).then(response => {
              if (!response.data.valid) {
                this.xsltValidationMessage = response.data.message;
                return;
              } else {
                this.xsltValidationMessage = "";
                let actionObj = this.constructActionObject();
                XVATRulesService.$emit("event:addAction", actionObj);
                this.hide();
              }
            });
          } else {
            let actionObj = this.constructActionObject();
            XVATRulesService.$emit("event:addAction", actionObj);
            this.hide();
          }
        }
      });
    },

    /**
     * updateAction - update action details
     */
    updateAction() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.action.actionType === "runXslt") {
            // Validation for XSLT
            this.validateXSLT(this.xsltValue).then(response => {
              if (!response.data.valid) {
                this.xsltValidationMessage = response.data.message;
                return;
              } else {
                this.xsltValidationMessage = "";
                let actionObj = this.constructActionObject();
                XVATRulesService.$emit("event:updateAction", actionObj);
                XVATRulesService.$emit("event:displaySaveRuleMsg");
                this.hide();
              }
            });
          } else {
            let actionObj = this.constructActionObject();
            XVATRulesService.$emit("event:updateAction", actionObj);
            XVATRulesService.$emit("event:displaySaveRuleMsg");
            this.hide();
          }
        }
      });
    },

    /**
     * deleteAction - Delete action
     */
    deleteAction() {
      XVATRulesService.$emit("event:deleteAction", this.action);
      this.deleteDialog = false;
      XVATRulesService.$emit("event:displaySaveRuleMsg");
      this.hide();
    },

    /**
     * constructActionObject - Construct action object
     */
    constructActionObject() {
      const actionType = this.action.actionType;
      let actionObject = {
        title: this.action.title,
        field: this.action.field,
        actionType: this.action.actionType
      };

      // Add id if it does't exist
      if (
        this.$lodash.isUndefined(this.action.id) ||
        this.$lodash.isEmpty(this.action.id)
      ) {
        actionObject.id = uniqid();
      } else {
        // Use existing id
        actionObject.id = this.action.id;
      }

      switch (actionType) {
        case "insertAttribute":
          actionObject.attributeName = this.action.attributeName;
          actionObject.attributeValue = this.action.attributeValue;
          break;
        case "deleteAttribute":
          actionObject.attributeName = this.action.attributeName;
          break;
        case "insertElement":
          actionObject.elementName = this.action.elementName;
          break;
        case "updateElement":
          actionObject.elementName = this.action.elementName;
          break;
        case "deleteElement":
          // No change
          break;
        case "insertAppData":
          actionObject.assetClass = this.action.assetClass;
          actionObject.appDataName = this.action.appDataName;
          actionObject.appDataValue = utils.escapeXMLString(
            this.action.appDataValue
          );
          actionObject = this.$lodash.omit(actionObject, ["field"]);
          break;
        case "runXslt":
          actionObject.xslt = this.xsltValue;
          actionObject.field = "";
          break;
      }

      console.log("Action Object", actionObject);
      return actionObject;
    },

    /**
     * populateActionData - Update view with action data
     * @param {object} actionObj
     */
    populateActionData(actionObj) {
      if (this.action.actionType === "runXslt") {
        this.xsltValue = actionObj.xslt;
      }
    },

    /**
     * Handles Action Type selection change
     * */
    handleActionTypeChange(actionType) {},

    /**
     * retrieveXPathMappings - Retreive mappings to display field dropdown
     */
    retrieveXPathMappings() {
      // Update store with xpath mappings
      if (this.xpathMappingsList.length === 0) {
        this.loadingXpathMappings = true;
        this.GET_XPATH_MAPPINGS_LIST()
          .catch(() => {
            // TODO: handle error
          })
          .finally(() => {
            this.loadingXpathMappings = false;
          });
      } else {
        return Promise.resolve(this.xpathMappingsList);
      }
    },

    /**
     * resetActionDetails - Reset action data and form
     */
    resetActionDetails() {
      this.resetActionData();
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },

    /**
     * Validate XSLT Value
     * @param {*} xsltValue
     */
    validateXSLT(xsltValue) {
      return xvatRulesDataService
        .validateXML(xsltValue)
        .then(response => {
          return response;
        })
        .catch(error => {
          Promise.reject(error);
        });
    }
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages;
    /**
     * Initial data
     */
    this.retrieveXPathMappings();
    /**
     * Events
     */
    XVATRulesService.$on("event:showActionDetailsSheet", this.show);
    XVATRulesService.$on("event:ruleDataRetrieved", this.hide);
  },
  beforeDestroy() {
    XVATRulesService.$off("event:showActionDetailsSheet", this.show);
    XVATRulesService.$off("event:ruleDataRetrieved", this.hide);
  }
};
</script>

<style lang="scss">
.action-details {
  min-height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/XVAT/Rule/ActionDetails.vue